module.exports = __webpack_public_path__ + "img/3.19cae7e7.png";